import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ServerErrorPageComponent } from './server-error-page.component';
import { MessagePageModule } from '../message-page/message-page.module';

@NgModule({
  imports: [CommonModule, MessagePageModule],
  declarations: [ServerErrorPageComponent],
  exports: [ServerErrorPageComponent],
})
export class ServerErrorPageModule {}
